module.exports = __webpack_public_path__ + "img/methodology_c.0c662057.png";